import Vue from 'vue'
import App from './App.vue'
import router from './router'

//引入复制粘贴的js

// Vue.use(Clipboard)
//按需导入的vant组件
import './Vant/index.js'

import './assets/css/global.css' //引入公共css样式文件
Vue.config.productionTip = false

import globel from './components/globel.vue'
Vue.prototype.globel = globel

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app')
